<div class="content">
    <div class="row">
        <div class="col-sm-12">
            <form class="form" [formGroup]="lcForm">
                <input type="hidden" id="id" formControlName="id" class="form-control">
                <input type="hidden" id="date" formControlName="date" class="form-control">
                <input type="hidden" id="project" formControlName="project" class="form-control">

                <div class="row">
                    <div class="col-sm-10">
                        <h5 *ngIf="lcService.selectedEditMode == false">New Lc</h5>
                        <h5 *ngIf="lcService.selectedEditMode == true">Edit Lc</h5>
                    </div>
                    <div class="col-sm-2">
                        <button type="button" class="close" aria-label="Close" title="Close" (click)="lcService.onCloseForm()">
                                 <span aria-hidden="true"> &times;</span>
                              </button>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form form-group">
                            <label>Name*</label>
                            <input type="text" class="form-control" formControlName="name" #s_name (change)="nameCheckUnique()" />
                        </div>
                        <div *ngIf="lcForm.controls['name'].invalid && (lcForm.controls['name'].dirty || lcForm.controls['name'].touched)" class="alert alert-danger">
                            <div *ngIf="lcForm.controls['name'].errors.required">
                                Name is required.
                            </div>
                            <div *ngIf="lcForm.controls['name'].errors.name">
                                Enter Valid Name
                            </div>
                        </div>
                        <div *ngIf="nameAlredyExist != ''" class="alert alert-danger">
                            {{nameAlredyExist}}
                        </div>
                    </div>
                </div>





                <div class="row">
                    <div class="col-sm-4">
                        <div class="form form-group">
                            <label>displacement*</label>
                            <input type="number" step=".01" id="displacement" formControlName="displacement" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form form-group">
                            <label>lcg*</label>
                            <input type="number" step=".01" id="lcg" formControlName="lcg" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form form-group">
                            <label>vcg*</label>
                            <input type="number" step=".01" id="vcg" formControlName="vcg" class="form-control">
                        </div>
                    </div>
                </div>



                <div class="row" style="padding-top: 10px;">
                    <div class="col-sm-11">
                    </div>

                    <div class="col-sm-1" *ngIf="(lcService.selectedEditMode == false)">
                        <button type="submit" class="btn btn-success" [disabled]="!lcForm.valid || nameAlredyExist != ''"><i class="bx bxs-save font-size-50"(click)="onSubmit()" title="Save data"></i></button>
                        <div class="textUnderIcon">Save</div>
                    </div>

                    <div class="col-sm-1" *ngIf="(lcService.selectedEditMode == true)">
                        <button type="submit" class="btn btn-success" [disabled]="!lcForm.valid || nameAlredyExist != ''"><i class="bx bxs-edit-alt font-size-50"(click)="onSubmit()" title="Save edited data"></i></button>
                        <div class="textUnderIcon">Edit</div>
                    </div>

                </div>

            </form>
        </div>
    </div>
</div>